var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1620 753L1620 781",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1620.5,
    cy: 748.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1615.99 748.19C1615.99 744.283 1619.29 741.117 1623.36 741.117C1623.94 741.117 1624.51 741.184 1625.06 741.308C1623.74 740.48 1622.19 740 1620.52 740C1615.81 740 1612 743.806 1612 748.5C1612 753.194 1615.81 757 1620.52 757C1622.81 757 1624.89 756.093 1626.43 754.62C1625.49 755.032 1624.45 755.263 1623.36 755.263C1619.29 755.263 1615.99 752.096 1615.99 748.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1629.4 747.6L1629.37 745.146L1627.54 746.719L1625.3 746.056L1626.11 748.337L1624.77 750.381L1627.1 750.218L1628.5 752.144L1629.13 749.763L1631.34 748.909L1629.4 747.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch1);
export default __webpack_public_path__ + "static/media/church_1.d15517e8106ea4d82566824a3bbda558.svg";
export { ForwardRef as ReactComponent };